import type { TMediaAnalysisRecord } from 'app/queries/media/collectMediaAnalysisRecords';

export const getMediaAnalysisRecord = (
  recordsByMediaId: Record<string, TMediaAnalysisRecord> | undefined,
  mediaId: string,
): TMediaAnalysisRecord | undefined =>
  recordsByMediaId ? recordsByMediaId[mediaId] ?? { analysisStatus: null, duration: 0 } : undefined;
